import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp, faFacebookF } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const direccion = "Catamarca 270, La Rioja";
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;

    return (
        <div className='FooterContain'>
            <div className='footerContent'>
                
                {/* LOGO DE CHENILLE */}
                <div className='footerLogo'>
                    <img src="/logo.png" alt="Chenille Muebles" />
                </div>

                {/* TÍTULO DE CONTACTO */}
                <h3 className='footerTitle'>Contacto</h3>

                {/* DIRECCIÓN Y EMAIL */}
                <div className='footerInfo'>
                    <a 
                        href={googleMapsUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='footerLink'
                    >
                        <FontAwesomeIcon icon={faMapMarkerAlt} className='footerIcon' />
                        <span>{direccion}</span>
                    </a>

                    <a 
                        href="mailto:contacto@chenillemuebles.com" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='footerLink'
                    >
                        <FontAwesomeIcon icon={faEnvelope} className='footerIcon' />
                        <span>contacto@chenillemuebles.com</span>
                    </a>
                </div>

                {/* REDES SOCIALES */}
                <div className='footerSocials'>
                    <a 
                        href="https://www.instagram.com/chenillemuebles" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='socialBtn'
                        aria-label="Instagram"
                    >
                        <FontAwesomeIcon icon={faInstagram} />
                    </a>
                    <a 
                        href="https://wa.me/5493804660709" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='socialBtn'
                        aria-label="WhatsApp"
                    >
                        <FontAwesomeIcon icon={faWhatsapp} />
                    </a>
                    <a 
                        href="https://www.facebook.com/chenillemuebles" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='socialBtn'
                        aria-label="Facebook"
                    >
                        <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                </div>



            </div>
        </div>
    );
}